export default {
  global: {
    getUploadConfig: ['get', '/upload/:type'], // 获取上传服务配置
  }
}
